import {Organization} from './organization.types';

export const FALLBACK_ORGANIZATION: Organization = {
  copyOverrides: {},
  id: 0,
  googleStaffTenantId: '',
  googlePatronTenantId: '',
  name: '',
  slug: '',
  websiteUrl: '',
  staffUrl: '',
  opacUrl: '',
  iconUrl: '',
  bannerUrl: '',
  manualAddressVerificationUrl: '',
  policyUrl: '',
  invitationEmail: '',
  contactEmail: '',
  arcgisBoundaryUrl: '',
  phoneNumber: '',
  hooplaLibraryId: '',

  novelistProfile: '',
  novelistPassword: '',
  enableBowkerMetadata: false,
  usesMEL: true,

  coverImageSource: 'CHILIFRESH',
  opacCardPolicy: '',
  active: false,
  created: '',
  modified: '',

  demoOrganization: false,
  demoStaffUsername: '',
  demoStaffPassword: '',
  demoOpacUsername: '',
  demoOpacPassword: '',
}
